import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doChangeChannelSetting } from '../store/actions/channelSettings';
import { selectCurrentChannelId, selectChannelSettings } from '../store/selectors';
import { ChannelSettings } from '../store/reducers/channelSettings';
import { RootState } from '../store/reducers/persistedReducer';
import { ReactComponent as CheckIcon } from '../images/check.svg'

import formStyles from './Form.module.scss';

function FormChannelSettings() {
  const dispatch = useDispatch();
  const channelId = useSelector(selectCurrentChannelId);
  const channelSettings = useSelector((state: RootState) => selectChannelSettings(state, channelId));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const property = e.currentTarget.name  as keyof ChannelSettings;
    const value = e.currentTarget.type === "checkbox" ? (e.currentTarget.checked ? true : false) : e.currentTarget.value;
    dispatch(doChangeChannelSetting({
      channelId: channelId!,
      property,
      value
    }))
  };

  return (
    <form className={formStyles.settingsForm}>
      <fieldset>
        <legend>Initial Centroid Selection</legend>
        <label>Channel Default <input type="radio" name="initialCentroid" checked={channelSettings.initialCentroid === "default"} value="default" onChange={handleChange} /><CheckIcon /></label>
        <label>Last Viewed <input type="radio" name="initialCentroid" checked={channelSettings.initialCentroid === "last"} value="last" onChange={handleChange}/><CheckIcon /></label>
      </fieldset>

      <fieldset>
        <legend>Cell Appearance</legend>
        <label>Show Cell Family Colors <input type="checkbox" name="showFamilyColors" checked={channelSettings.showFamilyColors} onChange={handleChange} /><CheckIcon /></label>
      </fieldset>

      <fieldset>
        <legend>Channel Updates</legend>
        <label>Prompt <input type="radio" name="channelUpdates" checked={channelSettings.channelUpdates === "prompt"} value="prompt" onChange={handleChange} /><CheckIcon /></label>
        <label>Display Immediately <input type="radio" name="channelUpdates" checked={channelSettings.channelUpdates === "immediate"} value="immediate" onChange={handleChange} /><CheckIcon /></label>
      </fieldset>
    </form>
  );
}

export default FormChannelSettings;

